import { Text } from '@components/primitives';
import appStyles from '@root/appStyles';
import colors from '@theme/colors';
import React from 'react';
import { TextStyle } from 'react-native';

interface BankForTransfer {
  beneficiaryName: string;
  accountNumber: string;
  bank: {
    bankName: string;
  };
}

interface AmountErrors {
  amount?: string;
}

export function shouldShowBeneficiaryNameWhenBankSelected(bankForTransfer: BankForTransfer | null): JSX.Element | null {
  return bankForTransfer === null ? null : (
    <Text variant="sm-normal" color={colors.neutral.darkMist}>
      {bankForTransfer.beneficiaryName}
    </Text>
  );
}

export function variantForSelectedBank(bankForTransfer: BankForTransfer | null): 'md-normal' | 'md-bold' {
  return bankForTransfer === null ? 'md-normal' : 'md-bold';
}

export function styleForSelectedBank(bankForTransfer: BankForTransfer | null): TextStyle | null {
  return bankForTransfer === null ? appStyles.flex1 : null;
}

export function colorForSelectedBank(bankForTransfer: BankForTransfer | null): string {
  return bankForTransfer === null ? colors.neutral.darkMist : colors.neutral.charcoal;
}

export function shouldShowBankNameWhenBankSelected(bankForTransfer: BankForTransfer | null): string {
  if (bankForTransfer === null) {
    return 'Pilih Rekening';
  }
  const name = bankForTransfer.bank.bankName;
  return name.length > 10 ? `${name.slice(0, 10)}...` : name;
}

export function shouldShowSeperatorWhenBankSelected(bankForTransfer: BankForTransfer | null): JSX.Element | null {
  return bankForTransfer === null ? null : (
    <Text variant="sm-normal" style={appStyles.marginHorizontal(4)}>
      |
    </Text>
  );
}

export function shouldShowAccountNumberWhenBankSelected(bankForTransfer: BankForTransfer | null): JSX.Element | null {
  return bankForTransfer === null ? null : (
    <Text variant="md-normal" style={appStyles.flex1}>
      {bankForTransfer.accountNumber}
    </Text>
  );
}

export function shouldShowErrorForAmounts(errors: AmountErrors): JSX.Element | null {
  return errors.amount ? (
    <Text variant="md-normal" color={colors.error.rose}>
      {errors.amount}
    </Text>
  ) : null;
}
